import { useRef, useState } from "react";
import api, { API } from "../../lib/api";
import { getToken } from "../../lib/tokenStorage";
import { toast } from "sonner";
import { Upload } from "lucide-react";

export default function LogoUploader({ me, onUpdated }) {
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);
  const upload = async (file) => {
    if (!file) return;
    setBusy(true);
    try {
      const fd = new FormData(); fd.append("file", file);
      await api.post("/partner-portal/logo", fd, { headers: { "Content-Type": "multipart/form-data" } });
      toast.success("Logo updated");
      onUpdated?.();
    } catch (e) { toast.error(e?.response?.data?.detail || "Failed"); }
    finally { setBusy(false); if (ref.current) ref.current.value = ""; }
  };
  const logoId = me?.profile_pic_id || me?.partner_profile?.logo_id;
  return (
    <div className="flex items-center gap-3">
      {logoId ? (
        <img src={`${API}/files/${logoId}?auth=${getToken()}`} alt="Logo" className="w-16 h-16 rounded-lg object-cover border-2 border-[color:var(--aii-green-tint)]"/>
      ) : (
        <div className="w-16 h-16 rounded-lg bg-[color:var(--aii-green-tint)] flex items-center justify-center font-display font-bold text-lg text-brand">{(me?.name || "?")[0]}</div>
      )}
      <div>
        <button onClick={() => ref.current?.click()} disabled={busy} data-testid="partner-logo-upload" className="text-xs px-3 py-1.5 border border-[color:var(--aii-border)] rounded-md hover:bg-[color:var(--aii-green-tint)] flex items-center gap-1"><Upload size={11}/> {busy ? "Uploading…" : (logoId ? "Change logo" : "Upload logo / photo")}</button>
        <input ref={ref} type="file" accept="image/*" className="hidden" onChange={(e) => upload(e.target.files?.[0])}/>
        <div className="text-[11px] text-[color:var(--aii-muted)] mt-1">Shown on your partner profile · max 5 MB</div>
      </div>
    </div>
  );
}
